import { ActionType } from '@ant-design/pro-components';
import { useRef } from 'react';

// 暂未启用
export default () => {
  const actionRef = useRef<ActionType>();
  return { actionRef };
};
